import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { LWApiPublicAssetCancellationReasonListResultRawI } from '@liquidweb-dev/club-sauce/public/asset/cancellation/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

const normaliseReasonList = (
	data: LWApiPublicAssetCancellationReasonListResultRawI,
): { type: string; label: string }[] => {
	return data.items.flatMap((item) => [
		{ type: 'category', label: item.category },
		...item.reasons.map((reason) => ({
			type: 'reason',
			label: reason,
		})),
	]);
};

export const ASSET_CANCELLATION_REASON_LIST_QUERY_KEY =
	'/asset/cancellation/reasonList';

const useAssetCancellationReasonList = (
	options?: UseQueryOptions<
		LWApiPublicAssetCancellationReasonListResultRawI,
		ApiErrorI,
		{ type: string; label: string }[]
	>,
) => {
	return useQuery({
		queryKey: [ASSET_CANCELLATION_REASON_LIST_QUERY_KEY],
		queryFn: () => api.asset.cancellation.apiRaw.reasonList(),
		select: normaliseReasonList,
		...options,
	});
};

export default useAssetCancellationReasonList;
